import axios, { CancelTokenSource } from "axios"
import { BalanceSituacionByFilterAdapter } from "./BalanceSituacion.adapter"
import { InformeTableDataDtoProps } from "./DTOs/InformeTableDataDto"

interface BalanceSituacionParams {
  EsMensual?: boolean
  Tipo?: number
  FechaFinMovimiento?: string
  FechaInicioMovimiento?: string
  Keyword?: string
  TipoInforme?: number
  SoloCuentasConSaldo?: boolean
}

// eslint-disable-next-line import/no-mutable-exports
export let BalanceSituacionCall: CancelTokenSource
export const getBalanceSituacionByFilters = async (
  queryParams?: BalanceSituacionParams
): Promise<InformeTableDataDtoProps> => {
  if (typeof BalanceSituacionCall !== typeof undefined) {
    BalanceSituacionCall.cancel("Previous Request Cancelled")
  }
  BalanceSituacionCall = axios.CancelToken.source()
  const { data }: { data: InformeTableDataDtoProps } = await axios.get(
    `BalanceSituacion/by-filters`,
    { params: queryParams, cancelToken: BalanceSituacionCall.token }
  )
  return BalanceSituacionByFilterAdapter(data)
}

export const generateBalanceSituacionExcel = (
  queryParams?: BalanceSituacionParams
) => {
  return axios.get(`BalanceSituacion/generate-excel`, {
    params: queryParams,
    responseType: "blob",
  })
}
